import Shared from '@/shared'

export const getCurrentLatLng = (): Promise<{ lat: number; lng: number }> => {
  // NOTE: geolocation API를 사용하면, https 환경에서만 사용 가능하다. (localhost는 예외)
  if (!window.navigator.geolocation) {
    return Promise.reject(new Shared.Errors.GeolocationError())
  }
  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords
        resolve({ lat: latitude, lng: longitude })
      },
      () => reject(new Shared.Errors.GeolocationError())
    )
  })
}
